import * as tslib_1 from "tslib";
import config from '@/config';
import { Component, Prop, Vue } from 'vue-property-decorator';
let setAddress = class setAddress extends Vue {
    constructor() {
        super(...arguments);
        this.receiver = {};
    }
    get address() {
        return `${this.receiver.province_name}${this.receiver.city_name}${this
            .receiver.district_name || ''}${this.receiver.address}`;
    }
    get addImg() {
        if (this.receiverInfo && this.receiverInfo.id) {
            return require('./images/btn_changeAdd.png');
        }
        else {
            return require('./images/btn_address.png');
        }
    }
    created() {
        if (this.receiverInfo && this.receiverInfo.id) {
            this.receiver = this.receiverInfo;
        }
        this.showAddress();
    }
    async toAddressList() {
        let receiver_id = this.receiver.id;
        let _head = location.origin;
        if (config.env != 'production') {
            _head = 'http://m.ivydad.com.cn';
        }
        let _redirect = `${window.location.origin}${window.location.pathname}`;
        window.location.replace(`${_head}/center/address/addressList?mode=select${receiver_id ? '&receiverId=' + receiver_id : ''}&redirect=` + encodeURIComponent(_redirect));
    }
    async showAddress() {
        // receiver就是接收的传回来的地址
        let { receiver_id } = this.$route.query;
        let url = window.location.href.replace(/(\?|#)[^'"]*/, ''); //去除参数
        window.history.pushState({}, '0', url);
        if (!receiver_id)
            return;
        //如果有旧的收货信息，得先看下是否更换，未更换 不需要保存
        if (this.receiverInfo && this.receiverInfo.id) {
            if (+receiver_id === +this.receiverInfo.id)
                return;
        }
        let { data } = await this.$axios.post(`/api/mobile/course/yaya/getUserReceiver`);
        let checkAddress = data.find(item => {
            if (receiver_id) {
                return item.id === +receiver_id;
            }
            else {
                return item.is_default;
            }
        }) || {};
        // receiver就是接收的传回来的地址
        this.receiver = checkAddress;
        this.$emit('update:receiverChange', checkAddress);
        await this.$axios.post('/api/activity/h5Activity/9thActivity/saveRewardAddress', {
            receiver_id: this.receiver.id,
        });
    }
    clickClose() {
        this.$emit('closeAddress');
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], setAddress.prototype, "receiverInfo", void 0);
setAddress = tslib_1.__decorate([
    Component({})
], setAddress);
export default setAddress;
